module.exports = __webpack_public_path__ + "static/media/weekend-argus.1e264b30.svg";